
let Data = [
    {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12816462/2020/11/24/ba18a805-4903-48a4-a136-c60ca39b22911606200984349-HERENOW-Men-Tshirts-1551606200983033-1.jpg",
        "brand": "HERE&NOW",
        "type": "Tshirt",
        "price": "227",
        "MP": "649",
        "offer": 65,
        color: "white",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1816490/2018/4/7/11523090829974-HIGHLANDER-Men-Black-Slim-Fit-Solid-Round-Neck-T-shirt-2051523090829712-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "351",
        "MP": "549",
        "offer": 36,
        color:  "black",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11306992/2020/6/9/ea2607ea-c2d3-4d27-94c3-5a67a76de4fd1591692498694-Roadster-Men-Tshirts-811591692497497-1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "299",
        "MP": "599",
        "offer": 50,
        color: "gray",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9793521/2022/4/18/2924525f-037f-4021-b065-761d590593cf1650284877470RoadsterMenMaroonSolidRoundNeckPureCottonT-shirt1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "329",
        "MP": "599",
        "offer": 45,
        color: "brown",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2216201/2017/11/30/11512038271694-Roadster-Men-Black-Solid-Round-Neck-T-shirt-8171512038271594-1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "349",
        "MP": "699",
        "offer": 50,
        color: "black",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1996725/2018/1/10/11515567400610-Roadster-Men-Blue-Solid-V-Neck-T-shirt-7321515567400387-1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "299",
        "MP": "599",
        "offer": 50,
        color: "blue",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1018611/2016/3/4/11457076915444-ETHER-Supima-White-T-shirt-2431457076914677-1.jpg",
        "brand": "ether",
        "type": "Tshirt",
        "price": "329",
        "MP": "599",
        "offer": 45,
        color: "white",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2275373/2018/1/24/11516793428292-Roadster-Men-Charcoal-Solid-Round-Neck-T-shirt-3641516793428158-1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "199",
        "MP": "399",
        "offer": 50,
        color: "black",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10384503/2022/4/12/85aee619-a4ec-4c09-a456-e47412956b951649749384737-Roadster-Men-Olive-Green-Solid-Round-Neck-Pure-Cotton-T-shir-1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "299",
        "MP": "599",
        "offer": 50,
        color: "green",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10941384/2020/2/13/9447a845-892a-49f5-91ee-4de8a6589a541581587257528-Roadster-Men-Tshirts-8221581587255142-1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "549",
        "MP": "999",
        "offer": 45
        ,
        color: "black",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2310354/2018/2/15/11518692015450-Roadster-Men-Tshirts-3681518692015229-1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "239",
        "MP": "599",
        "offer": 60,
        color: "white",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/3314157/2018/4/18/11524041081440-Roadster-Men-Grey-Melange-Solid-Round-Neck-T-shirt-3461524041081257-1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "324",
        "MP": "499",
        "offer": 35,
        color: "gray",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13552828/2021/11/18/f5f8618d-7983-46ec-833d-ea7a650e20201637222081460-Bewakoof-Men-White-Pure-Cotton-T-shirt-5811637222081380-18.jpg",
        "brand": "Bewakoof",
        "type": "Tshirt",
        "price": "399",
        "MP": null,
        "offer": null,
        color: "white",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2306179/2019/3/8/649510bf-570a-4743-88bd-0bb1f354d3fe1552026562116-Roadster-Men-White-Solid-V-Neck-T-shirt-8741552026560838-1.jpg",
        "brand": "Roadster",
        "type": "Tshirt",
        "price": "299",
        "MP": "599",
        "offer": 50,
        color: "white",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10188591/2019/9/26/70f45aeb-477e-48fb-b5e4-8820904196271569490421369-WROGN-Men-Burgundy-Solid-Slim-Fit-Round-Neck-T-shirt-9361569-1.jpg",
        "brand": "WROGN",
        "type": "Tshirt",
        "price": "539",
        "MP": "899",
        "offer": 40,
        color: "brown",
      },
    
    
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10144535/2019/8/5/1a759a1a-0ed9-4ec1-981b-677e2626d35f1565006028143-HIGHLANDER-Men-Maroon--Navy-Blue-Colourblocked-Round-Neck-T--1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "314",
        "MP": "699",
        "offer": 55,
        color: "brown",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15743580/2021/10/5/5aa6da0f-f7c2-4297-9e5b-071f7e1c24691633438479239HIGHLANDERMenBlueTypographyColourblockedAppliqueSlimFitT-shi1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "383",
        "MP": "799",
        "offer": 52,
        color: "blue",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15745700/2021/10/5/967afa60-cd28-4e43-8973-f9583f1e31e31633446113055LOCOMOTIVEMenYellowPrintedAppliqueSlimFitT-shirt1.jpg",
        "brand": "LOCOMOTIVE",
        "type": "Tshirt",
        "price": "305",
        "MP": "899",
        "offer": 66,
        color: "white",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16090654/2021/11/15/eb85a9ee-b22a-430e-be26-fc0820d753fc1636962642465HIGHLANDERMenNavyBlueStripedPocketsSlimFitT-shirt1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "375",
        "MP": "799",
        "offer": 53,
        color: "black",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16199500/2021/11/22/535244ac-818c-40e7-8562-f15f5c7552a11637584155501HIGHLANDERMenBlackPrintedAppliqueSlimFitT-shirt1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "367",
        "MP": "749",
        "offer": 51,
        color: "black",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15745640/2021/10/5/6e85c52c-301f-4f41-9844-108159acfa191633447633181HIGHLANDERMenBlueColourblockedRawEdgeSlimFitT-shirt1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "424",
        "MP": "849",
        "offer": 50,
        color: "black",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12712306/2020/11/17/6df598db-88bb-49cb-aab7-5cbf0e6aecc51605597902989-Difference-of-Opinion-Men-Tshirts-8351605597901639-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "479",
        "MP": "1199",
        "offer": 60,
        color: "brown",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16199416/2021/11/22/b0482c0c-85f9-4053-b22c-7952fa7f3d6f1637588482413HIGHLANDERMenWhiteStripedV-NeckPocketsSlimFitT-shirt1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "337",
        "MP": "749",
        "offer": 55,
        color: "blue",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15744724/2021/10/5/18d6f1e6-d4df-4fd9-9c98-f50a8345be0c1633442522872HIGHLANDERMenYellowColourblockedV-NeckAppliqueSlimFitT-shirt1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "314",
        "MP": "699",
        "offer": 55,
        color: "yellow",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/1/13/406839f2-2e4b-4ee6-aeb6-2181f8a6ce571610544184841-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "329",
        "MP": "549",
        "offer": 40,
        color: "white",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16058652/2021/11/11/c60f82a5-46cf-4380-8de6-98ab179c71541636613864420HIGHLANDERMenRedColourblockedPocketsSlimFitT-shirt1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "404",
        "MP": "899",
        "offer": 55,
        color: "red",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15745722/2021/10/5/487c81c8-0c2d-4c98-b147-203da0e5bfb61633446131590LOCOMOTIVEMenWhiteColourblockedMonochromeAppliqueSlimFitT-sh1.jpg",
        "brand": "LOCOMOTIVE",
        "type": "Tshirt",
        "price": "271",
        "MP": "799",
        "offer": 66,
        color: "blue",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/5/4/a7607528-f35f-4f73-98bd-bfc22accab621620127738690-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "340",
        "MP": "549",
        "offer": 38,
        color: "black",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1777737/2018/3/30/11522393387675-HIGHLANDER-Men-Maroon--Black-Colourblocked-Slim-Fit-T-shirt-8451522393387513-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Tshirt",
        "price": "351",
        "MP": "549",
        "offer": 36,
        color: "brown",
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15745698/2021/10/5/5254ed70-55ee-4536-9cd5-e1276f2c80e31633445316064LOCOMOTIVEMenWhiteColourblockedRawEdgeSlimFitT-shirt1.jpg",
        "brand": "LOCOMOTIVE",
        "type": "Tshirt",
        "price": "271",
        "MP": "799",
        "offer": 66,
        color: "blue",
      },
    
    
    
      {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15971012/2021/12/22/5d3d8b9b-3086-4548-bcf8-872a8bd5e3601640157604736-ether-Men-Tshirts-2661640157604228-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "359",
          "MP": "899",
          "offer": 60,
          color: "yellow",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11752066/2022/3/15/64a7f608-dc0a-436b-ba48-ffff7b1230f21647328501205-ether-Men-Black-Henley-Neck-Cotton-Pure-Cotton-T-shirt-76516-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "439",
          "MP": "799",
          "offer": 45,
          color: "black",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15244906/2021/9/28/1e55c00e-6086-419a-b454-9d1be17f65bf1632832382167-ether-Men-Tshirts-4931632832381543-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "279",
          "MP": "799",
          "offer": 65,
          color: "black",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16121034/2022/1/20/e011d085-5c76-4b12-8d7b-1d1ff1f3df3e1642663308222-ether-Men-Black--Brown-Colourblocked-Pure-Cotton-T-shirt-496-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "359",
          "MP": "799",
          "offer": 55,
          color: "black",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14596840/2022/1/20/5f24a153-ceaa-4315-adcc-000dfb4e0e281642674783229-ether-Men-Black-Pure-Cotton-Pockets-T-shirt-6281642674782789-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "314",
          "MP": "699",
          "offer": 55,
          color: "black",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15971106/2022/2/21/c776df83-8195-427a-aba4-fd32c29a069d1645426622947-ether-Men-Tshirts-2591645426622384-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "1199",
          "MP": null,
          "offer": null,
          color: "green",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14596796/2021/10/13/472c8fc2-10e2-449e-8ac6-bc45599260341634118522523-ether-Men-Tshirts-9511634118522184-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "359",
          "MP": "899",
          "offer": 60,
          color: "blue",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13558398/2021/10/29/87bfea5c-551f-400b-b4f3-b8c287b850811635489675465-ether-Men-Tshirts-6481635489674859-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "349",
          "MP": "999",
          "offer": 65,
          color: "pink",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13555824/2021/7/27/e03f0811-821d-4b80-86f7-a9279393b6bd1627367778681-ether-Men-Tshirts-4151627367778264-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "349",
          "MP": "999",
          "offer": 65,
          color: "yellow",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15971084/2022/1/20/3cd0c18f-f685-4561-9870-4bcf4d41bc801642674373965-ether-Men-Grey-Melange-T-shirt-8941642674373440-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "299",
          "MP": "599",
          "offer": 50,
          color: "gray",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16121086/2022/2/15/b87fd5f0-7389-477c-995d-80e94f03c9831644906029108-ether-Men-Blue-Striped-T-shirt-5051644906028526-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "449",
          "MP": "899",
          "offer": 50,
          color: "blue",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14893288/2022/2/15/d445d62f-2b49-4226-bcda-5f55031622991644923467817-ether-Men-Tshirts-3381644923467290-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "439",
          "MP": "799",
          "offer": 45,
          color: "white",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14596708/2021/9/29/9a6e4cd1-5e7a-4a3d-a338-4560d417c3931632889994927-ether-Men-Tshirts-5751632889994388-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "319",
          "MP": "799",
          "offer": 60,
          color: "black",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15568040/2022/1/4/4d42305e-eb99-4cc7-a435-1a11cb8094c31641281271775-Roadster-Men-Tshirts-7121641281271268-1.jpg",
          "brand": "Roadster",
          "type": "Tshirt",
          "price": "439",
          "MP": "1099",
          "offer": 60,
          color: "black",
        },
        {
          "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16862688/2022/2/10/10f1ec3a-ce1f-4aea-901d-0e0803d6f79b1644477437108-ether-Men-Tshirts-3681644477436642-1.jpg",
          "brand": "ether",
          "type": "Tshirt",
          "price": "699",
          "MP": 1000,
          "offer": 18,
          color: "brown",
        },
    
    
    
    
    
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10144535/2019/8/5/1a759a1a-0ed9-4ec1-981b-677e2626d35f1565006028143-HIGHLANDER-Men-Maroon--Navy-Blue-Colourblocked-Round-Neck-T--1.jpg",
            "brand": "HIGHLANDER",
            "type": "Tshirt",
            "price": "314",
            "MP": "699",
            "offer": 55,
            color: "brown",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15743580/2021/10/5/5aa6da0f-f7c2-4297-9e5b-071f7e1c24691633438479239HIGHLANDERMenBlueTypographyColourblockedAppliqueSlimFitT-shi1.jpg",
            "brand": "HIGHLANDER",
            "type": "Tshirt",
            "price": "383",
            "MP": "799",
            "offer": 52,
            color: "blue",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15745700/2021/10/5/967afa60-cd28-4e43-8973-f9583f1e31e31633446113055LOCOMOTIVEMenYellowPrintedAppliqueSlimFitT-shirt1.jpg",
            "brand": "LOCOMOTIVE",
            "type": "Tshirt",
            "price": "305",
            "MP": "899",
            "offer": 66,
            color: "yellow",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16090654/2021/11/15/eb85a9ee-b22a-430e-be26-fc0820d753fc1636962642465HIGHLANDERMenNavyBlueStripedPocketsSlimFitT-shirt1.jpg",
            "brand": "HIGHLANDER",
            "type": "Tshirt",
            "price": "375",
            "MP": "799",
            "offer": 53,
            color: "blue",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16199500/2021/11/22/535244ac-818c-40e7-8562-f15f5c7552a11637584155501HIGHLANDERMenBlackPrintedAppliqueSlimFitT-shirt1.jpg",
            "brand": "HIGHLANDER",
            "type": "Tshirt",
            "price": "367",
            "MP": "749",
            "offer": 51,
            color: "black",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15745640/2021/10/5/6e85c52c-301f-4f41-9844-108159acfa191633447633181HIGHLANDERMenBlueColourblockedRawEdgeSlimFitT-shirt1.jpg",
            "brand": "HIGHLANDER",
            "type": "Tshirt",
            "price": "424",
            "MP": "849",
            "offer": 50,
            color: "black",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12712306/2020/11/17/6df598db-88bb-49cb-aab7-5cbf0e6aecc51605597902989-Difference-of-Opinion-Men-Tshirts-8351605597901639-1.jpg",
            "brand": "ether",
            "type": "Tshirt",
            "price": "479",
            "MP": "1199",
            "offer": 60,
            color: "black",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16199416/2021/11/22/b0482c0c-85f9-4053-b22c-7952fa7f3d6f1637588482413HIGHLANDERMenWhiteStripedV-NeckPocketsSlimFitT-shirt1.jpg",
            "brand": "HIGHLANDER",
            "type": "Tshirt",
            "price": "337",
            "MP": "749",
            "offer": 55,
            color: "blue",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15744724/2021/10/5/18d6f1e6-d4df-4fd9-9c98-f50a8345be0c1633442522872HIGHLANDERMenYellowColourblockedV-NeckAppliqueSlimFitT-shirt1.jpg",
            "brand": "HIGHLANDER",
            "type": "Tshirt",
            "price": "314",
            "MP": "699",
            "offer": 55,
            color: "yellow",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/1/13/406839f2-2e4b-4ee6-aeb6-2181f8a6ce571610544184841-1.jpg",
            "brand": "HIGHLANDER",
            "type": "Tshirt",
            "price": "329",
            "MP": "549",
            "offer": 40,
            color: "white",
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16058652/2021/11/11/c60f82a5-46cf-4380-8de6-98ab179c71541636613864420HIGHLANDERMenRedColourblockedPocketsSlimFitT-shirt1.jpg",
            "brand": "HIGHLANDER",
            "type": "Tshirt",
            "price": "404",
            "MP": "899",
            "offer": 55,
            color: "red",
          },
//   ]
  
  // tesirt data end here


  
  // Casual sirt  data here

//  let casualShirt =  [
    {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2284523/2018/2/15/11518684805969-Roadster-Men-Navy-Blue--Green-Regular-Fit-Checked-Casual-Shirt-4471518684805162-1.jpg",
        "brand": "Roadster",
        "type": "Shirts",
        "price": "674",
        "MP": "1499",
        "offer": 55
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1823142/2017/4/27/11493281526215-WROGN-Men-Navy-Blue-Slim-Fit-Checked-Casual-Shirt-5201493281525914-1.jpg",
        "brand": "WROGN",
        "type": "Shirts",
        "price": "1379",
        "MP": "2299",
        "offer": 40
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7488102/2019/8/22/8002a744-0dad-4dbb-9481-cf0090134c3b1566454086786-Dennis-Lingo-Men-Pink-Slim-Fit-Solid-Casual-Shirt-9891566454-1.jpg",
        "brand": "Dennis Lingo",
        "type": "Shirts",
        "price": "684",
        "MP": "1849",
        "offer": 63
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1362028/2016/8/31/11472638719005-Roadster-Men-Brown-Regular-Fit-Checked-Casual-Shirt-3421472638718814-1.jpg",
        "brand": "Roadster",
        "type": "Shirts",
        "price": "519",
        "MP": "1299",
        "offer": 60
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/6714923/2019/3/6/343e1235-336c-401e-beab-afbb828448231551863812172-Dennis-Lingo-Men-Black-Slim-Fit-Solid-Casual-Shirt-473155186-1.jpg",
        "brand": "Dennis Lingo",
        "type": "Shirts",
        "price": "684",
        "MP": "1849",
        "offer": 63
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2284691/2018/1/29/11517205743041-Roadster-Men-Black-Regular-Fit-Solid-Casual-Shirt-2871517205742822-1.jpg",
        "brand": "Roadster",
        "type": "Shirts",
        "price": "479",
        "MP": "1199",
        "offer": 60
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2338729/2018/8/30/25a48bec-c445-4e49-94f5-f85702bcd76e1535620402114-WROGN-Men-Red--Navy-Blue-Smart-Fit-Checked-Casual-Shirt-4501-1.jpg",
        "brand": "WROGN",
        "type": "Shirts",
        "price": "1499",
        "MP": "2499",
        "offer": 40
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1667052/2022/4/18/a987b75a-2aaa-4b2e-85fb-5cf8e01b383d1650284962264RoadsterMenKhakiCheckedCasualSustainableShirt1.jpg",
        "brand": "Roadster",
        "type": "Shirts",
        "price": "934",
        "MP": "1699",
        "offer": 45
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2019/3/8/75750a68-13fc-4bd5-b91e-bd879aca9e1b1552028704151-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Shirts",
        "price": "767",
        "MP": "1449",
        "offer": 47
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1758578/2017/5/12/11494569522819-WROGN-Men-Shirts-8521494569522516-1.jpg",
        "brand": "WROGN",
        "type": "Shirts",
        "price": "1264",
        "MP": "2299",
        "offer": 45
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1729391/2019/8/28/a9d4a7aa-af7e-4a37-a9d4-a94dc8c057e81566992341974-WROGN-Navy-Blue-Slim-Fit-Checked-Casual-Shirt-52415669923403-1.jpg",
        "brand": "WROGN",
        "type": "Shirts",
        "price": "1374",
        "MP": "2499",
        "offer": 45
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7324885/2019/12/4/f383d293-415a-4606-ab12-cc07ab603ec41575437710624-HIGHLANDER-Men-Brown--Black-Slim-Fit-Checked-Casual-Shirt-81-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Shirts",
        "price": "766",
        "MP": "1299",
        "offer": 41
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7288105/2018/10/24/a059288c-512c-468a-87d4-ce36b52840441540360274049-HERENOW-Men-Shirts-5241540360273894-1.jpg",
        "brand": "HERE&NOW",
        "type": "Shirts",
        "price": "569",
        "MP": "1899",
        "offer": 70
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2256562/2018/2/5/11517823140053-HIGHLANDER-Men-Black--Grey-Slim-Fit-Checked-Casual-Shirt-6531517823139956-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Shirts",
        "price": "739",
        "MP": "999",
        "offer": 26
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1265389/2018/2/7/11517995810352-Highlander-Black-Slim-Fit-Casual-Shirt-1061517995810069-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Shirts",
        "price": "639",
        "MP": "999",
        "offer": 36
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16044348/2021/11/9/66a7073f-9e01-4ba5-95f9-11930c6e10f71636459459715Dhotis1.jpg",
        "brand": "WHITE HEART",
        "type": "Shirt",
        "price": "485",
        "MP": "999",
        "offer": 20
      },
//   ]

  // casual sirt end here


 

  // jeans data start here

//   let jeansArr = [
    {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7786833/2019/9/25/55914283-1977-4328-9677-023537820a8b1569399773519-LOCOMOTIVE-Men-Grey-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-1.jpg",
        "brand": "LOCOMOTIVE",
        "type": "Jeans",
        "price": "1074",
        "MP": "2499",
        "offer": 57
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7243639/2022/4/19/868d6eee-0649-44e4-b17b-2aa3e3b0fc9c1650366028127RoadsterMenBlackSlimFitMid-RiseCleanLookJeans1.jpg",
        "brand": "Roadster",
        "type": "Jeans",
        "price": "679",
        "MP": "1699",
        "offer": 60
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8706061/2019/4/2/e5a76652-ca96-47de-a7f4-ca92dc2483581554196084705-HIGHLANDER-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchabl-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Jeans",
        "price": "688",
        "MP": "1299",
        "offer": 47
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10187401/2019/9/6/4d898c8c-ed5a-4e03-8618-1e60af1a261d1567759098279-WROGN-Men-Jeans-1021567759096713-1.jpg",
        "brand": "WROGN",
        "type": "Jeans",
        "price": "1299",
        "MP": "2599",
        "offer": 50
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7678836/2018/12/17/04fceac4-8e1b-4982-ba58-00485243a3481545031068966-Roadster-Men-Jeans-841545031064917-1.jpg",
        "brand": "Roadster",
        "type": "Jeans",
        "price": "764",
        "MP": "1699",
        "offer": 55
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/5669588/2018/6/12/0dcec4bb-3be9-4c67-9d9a-ecdcc937f98d1528807434080-Roadster-Men-Blue-Skinny-Fit-Mid-Rise-Mildly-Distressed-Stretchable-Jeans-4491528807433906-1.jpg",
        "brand": "Roadster",
        "type": "Jeans",
        "price": "934",
        "MP": "1699",
        "offer": 45
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/10885024/2019/11/13/adb31de4-d904-42f0-b754-456351b9e5b91573647637113-IVOC-Mens-Denim-Joggers-8411573647633226-1.jpg",
        "brand": "IVOC",
        "type": "Jeans",
        "price": "834",
        "MP": "1799",
        "offer": 965
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/6544937/2018/7/11/867f2bfa-64f5-4c29-afa0-eed584bddb751531295865569-Roadster-Men-Jeans-7681531295865401-1.jpg",
        "brand": "Roadster",
        "type": "Jeans",
        "price": "799",
        "MP": "1999",
        "offer": 60
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8673413/2019/3/14/4c4ba5c0-e87a-430e-a267-f48f20a703621552564719527-WROGN-Men-Black-Skinny-Fit-Mid-Rise-Clean-Look-Stretchable-J-1.jpg",
        "brand": "WROGN",
        "type": "Jeans",
        "price": "1559",
        "MP": "2599",
        "offer": 40
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12560198/2020/11/27/06786031-de7d-4adb-a02e-a00f1b4988e31606477259949-HERENOW-Men-Jeans-4651606477258027-1.jpg",
        "brand": "HERE&NOW",
        "type": "Jeans",
        "price": "599",
        "MP": "1999",
        "offer": 70
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2428491/2018/2/1/11517477484451-HERENOW-Men-Jeans-141517477484325-1.jpg",
        "brand": "HERE&NOW",
        "type": "Jeans",
        "price": "749",
        "MP": "2499",
        "offer": 70
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2150846/2017/10/19/11508406968179-HERENOW-Men-Blue-Slim-Fit-Mid-Rise-Mildly-Distressed-Stretchable-Jeans-7261508406968007-1.jpg",
        "brand": "HERE&NOW",
        "type": "Jeans",
        "price": "779",
        "MP": "2599",
        "offer": 70
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13823708/2022/4/26/ac356453-1770-442b-83d5-734f86645e2f1650961872384-Urbano-Fashion-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretc-1.jpg",
        "brand": "Urbano Fashion",
        "type": "Jeans",
        "price": "755",
        "MP": "1399",
        "offer": 46
      },
      
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1729344/2020/3/2/84a03c78-f8e5-4c20-942c-8ea6e4a9ed641583150812330-WROGN-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jea-1.jpg",
        "brand": "WROGN",
        "type": "Jeans",
        "price": "1439",
        "MP": "2399",
        "offer": 40
      },
//   ]

// jeans data end here



    // let casualTrauserARR = [
        {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/11/12/b58188ba-77dd-4fc7-bd86-c8cad24a4da91605128902262-1.jpg",
            "brand": "Wrong",
            "type": "Trousers",
            "price": "1699",
            "MP": 2000,
            "offer": 20
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13159756/2021/10/28/bba53106-be0b-4a56-9c54-938c050f1e681635397565779-HERENOW-Men-Khaki-Slim-Fit-Joggers-Trousers-6931635397565058-1.jpg",
            "brand": "HERE&NOW",
            "type": "Trousers",
            "price": "1139",
            "MP": "3799",
            "offer": 70
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/1/11/824792dc-9629-4d46-80cc-6f8995d7ef571610360852562-1.jpg",
            "brand": "Breakbounce",
            "type": "Joggers",
            "price": "1034",
            "MP": "2299",
            "offer": 55
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8209403/2019/8/22/691ae9ad-4342-4dd6-ae59-03601a27eafd1566479499415-HIGHLANDER-Men-Grey-Slim-Fit-Solid-Cargos-4361566479497959-1.jpg",
            "brand": "HIGHLANDER",
            "type": "Cargos",
            "price": "924",
            "MP": "1849",
            "offer": 50
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2389026/2018/2/13/11518499099305-Hubberholme-Men-Beige-Slim-Fit-Solid-Cargos-5611518499099225-1.jpg",
            "brand": "Hubberholme",
            "type": "Men Slim Fit Cargos",
            "price": "989",
            "MP": "1499",
            "offer": 34
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2343636/2018/4/3/11522753442408-HIGHLANDER-Men-Grey-Slim-Fit-Solid-Joggers-5881522753442218-1.jpg",
            "brand": "HIGHLANDER",
            "type": "Men Slim Fit Joggers",
            "price": "873",
            "MP": "1649",
            "offer": 47
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2389024/2018/2/13/11518499083955-Hubberholme-Men-Blue-Slim-Fit-Solid-Cargos-3051518499083872-1.jpg",
            "brand": "Hubberholme",
            "type": "Men Slim Fit Cargos",
            "price": "914",
            "MP": "1499",
            "offer": 39
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15923976/2021/10/26/e0d19c60-d23b-4570-b542-71206c9f116c1635231969002HIGHLANDERMenBlueSlimFitCargosTrousers1.jpg",
            "brand": "HIGHLANDER",
            "type": "Men Slim Fit Jogger Cargos",
            "price": "1085",
            "MP": "2049",
            "offer": 47
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13737006/2021/3/2/b337be4f-8f03-43a3-b893-845e9c5de9651614681709969-Hubberholme-Men-Trousers-991614681708306-1.jpg",
            "brand": "Hubberholme",
            "type": "Men Slim Fit Cargos Pants",
            "price": "929",
            "MP": "1499",
            "offer": 38
          },
          
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11761660/2022/4/7/9adffe9c-cd64-4ae8-9ad4-6f5c6c4d1b211649328829260HubberholmeMenBrownSlimFitSolidCargos1.jpg",
            "brand": "Hubberholme",
            "type": "Men Slim Fit Cargos",
            "price": "989",
            "MP": "1499",
            "offer": 34
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15193444/2021/8/19/2b5c68a8-6081-4f20-b33c-96d80c6b97a91629350010636Cargojoggers1.jpg",
            "brand": "H&M",
            "type": "Men Cargo Joggers",
            "price": "2699",
            "MP": null,
            "offer": null
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/4/9/07d57b24-1ea2-40b5-bbcb-3b6ecc40cfe31617971753593-1.jpg",
            "brand": "Pepe Jeans",
            "type": "Men Regular Fit Cargos",
            "price": "1799",
            "MP": "2999",
            "offer": 40
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2389029/2018/2/13/11518499123014-Hubberholme-Men-Brown-Slim-Fit-Solid-Cargos-441518499122964-1.jpg",
            "brand": "Hubberholme",
            "type": "Men Slim Fit Cargos",
            "price": "989",
            "MP": "1499",
            "offer": 34
          },
          {
            "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/2389028/2018/2/13/11518499115458-Hubberholme-Men-Navy-Blue-Slim-Fit-Solid-Cargos-9761518499115386-1.jpg",
            "brand": "Hubberholme",
            "type": "Men Slim Fit Cargos",
            "price": "914",
            "MP": "1499",
            "offer": 39
          },
//   ]

  //// casual trauser  end here 


  ///// footware section start here

  // CasualShoes start here
  

//    let casualShoesArr = [
    {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11756898/2021/12/14/066bfe87-ef05-4cc9-8769-cee2a63b50b91639473787244RoadsterMenWhiteSolidSneakers1.jpg",
        "brand": "Roadster",
        "type": "Men Solid Causel-Shoes",
        "price": "2899",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12068002/2021/8/5/0a5fec8d-e917-4e8f-9b71-0288a26be52e1628146013628HIGHLANDERMenWhiteSneakers1.jpg",
        "brand": "HIGHLANDER",
        "type": "Men Solid Causel-Shoes",
        "price": "995",
        "MP": "1990",
        "offer": 50
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11945014/2021/5/17/b214346d-8a65-4a91-b2e3-bf8f632db13f1621223871248-Provogue-Men-Blue-Loafers-5161621223871159-6.jpg",
        "brand": "Provogue",
        "type": "Men Solid Causel-Shoes",
        "price": "849",
        "MP": "4245",
        "offer": 80
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11756892/2021/12/14/e141e830-7352-4e67-a119-e6e8da1682fd1639478472050-Roadster-Men-Grey-Solid-Suede-Finish-Sneakers-75316394784715-1.jpg",
        "brand": "Roadster",
        "type": "Men Suede Finish Causel-Shoes",
        "price": "2999",
        "MP": null,
        "offer": null
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16016368/2021/11/5/a865e870-1060-4c73-b7fa-0f54a17d834b1636111288189MactreeMenWhiteColourblockedPUSneakers6.jpg",
        "brand": "Mactree",
        "type": "Men Colourblocked PU Causel-Shoes",
        "price": "744",
        "MP": "3720",
        "offer": 80
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2019/8/14/cd6632e5-a2c6-4ec2-a3d8-9a6a6c59e0f51565782726402-1.jpg",
        "brand": "H&M",
        "type": "Men Causel-Shoes",
        "price": "1999",
        "MP": null,
        "offer": null
      },
      
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12067992/2021/2/22/090fc394-cf26-43b7-807d-134ca7c68b911613970123853-HIGHLANDER-Men-White-Sneakers-5371613970122157-6.jpg",
        "brand": "HIGHLANDER",
        "type": "Men Solid Causel-Shoes",
        "price": "995",
        "MP": "1990",
        "offer": 50
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11986108/2021/8/5/68605977-c696-4351-b21c-f19ed8ba46951628146095530HIGHLANDERMenWhiteSolidSneakers1.jpg",
        "brand": "HIGHLANDER",
        "type": "Men Solid Causel-Shoes",
        "price": "995",
        "MP": "1990",
        "offer": 50
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15839406/2021/11/12/54e4c724-80c7-45f9-aa32-167ffa9623741636705114683-US-Polo-Assn-Men-Casual-Shoes-2501636705113615-1.jpg",
        "brand": "U.S. Polo Assn.",
        "type": "Men Solid Slip-On Causel-Shoes",
        "price": "1949",
        "MP": "2599",
        "offer": 25
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15630218/2021/9/29/bda9fe48-193c-4a64-8e2a-a8e60bd6e2d61632884288144Trainers1.jpg",
        "brand": "H&M",
        "type": "Men Causel-Shoes",
        "price": "1999",
        "MP": 2500,
        "offer": 22
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11497178/2020/2/24/717b8fd1-c6f0-4db9-8021-7f3e0201103e1582535122670-US-Polo-Assn-Men-White-Sneakers-9531582535121583-1.jpg",
        "brand": "U.S. Polo Assn.",
        "type": "Men Causel-Shoes",
        "price": "3999",
        "MP": 5000,
        "offer": 10
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12067984/2021/2/2/0425f19a-852a-45e6-a1f6-7c80526a158f1612240158034-HIGHLANDER-Men-White-Sneakers-2351612240156845-6.jpg",
        "brand": "HIGHLANDER",
        "type": "Men Solid Causel-Shoes",
        "price": "995",
        "MP": "1990",
        "offer": 50
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/9785479/2021/2/17/9b109c7d-39f4-499c-9900-8e2e394cf75d1613525159914LOCOMOTIVEMenWhiteSneakers1.jpg",
        "brand": "LOCOMOTIVE",
        "type": "Men Causel-Shoes",
        "price": "895",
        "MP": "995",
        "offer": 10
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11097166/2019/12/10/cb47b7dc-e28a-4559-8388-8b82762b27681575980908117-HIGHLANDER-Men-White-Sneakers-661575980906633-1.jpg",
        "brand": "HIGHLANDER",
        "type": "Men Causel-Shoes",
        "price": "995",
        "MP": "1990",
        "offer": 50
      },
//   ]

  /// casual shoes end here///

  //sports arr 


//   let SportsShoesArr = [
    {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/8058351/2022/1/4/5c0a11c6-3193-43d1-99ad-067b264b8cf61641295613595-HRX-by-Hrithik-Roshan-Men-Black-Urban-Outdoor-Running-Shoe-4-1.jpg",
        "brand": "HRX",
        "type": "Men Urban Outdoor Sports-Shoes",
        "price": "3024",
        "MP": "5499",
        "offer": 45
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15226458/2021/8/23/abda7767-9bdb-48cb-90c8-026efaeabffc1629721241687SportsShoes1.jpg",
        "brand": "Puma",
        "type": "Men Anzarun Lite V3 IDP Sports-Shoes",
        "price": "2449",
        "MP": "3499",
        "offer": 30
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13483748/2022/3/24/a5439bbb-226b-4104-bbd2-64d3d9998d6b1648107968374PumaMenWhiteCELLVALIANTSLRunningShoes1.jpg",
        "brand": "Puma",
        "type": "Men CELL VALIANT SL Sports-Shoes",
        "price": "4549",
        "MP": "6999",
        "offer": 35
      },
      
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14824822/2021/8/23/4c997245-e8d5-4e56-8a91-9096693d80131629712617426-Puma-Men-Sports-Shoes-521629712616966-1.jpg",
        "brand": "Puma",
        "type": "Men Jamming 2.0 Running Sports-Shoes",
        "price": "11049",
        "MP": "12999",
        "offer": 15
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/6703466/2018/6/11/93a747f9-54da-4f47-97db-a812de6702251528698311878-Running-1351528698311718-1.jpg",
        "brand": "Puma",
        "type": "Men Running Sports-Shoes",
        "price": "3574",
        "MP": "5499",
        "offer": 35
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11938692/2020/6/15/8e39d227-b791-4d60-8442-be820bcc0dcf1592217999977Pumagrey1.jpg",
        "brand": "Puma",
        "type": "Men Running Sports-Shoes",
        "price": "2399",
        "MP": "3999",
        "offer": 40
      },
      
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14521968/2021/12/24/3a3cc02d-17bc-4423-8fc2-342a1b00d1df1640343251519-Puma-Men-Black-Mesh-Running-Shoes-1071640343251207-1.jpg",
        "brand": "Puma",
        "type": "Eternity Nitro Running Sports-Shoes",
        "price": "11049",
        "MP": "12999",
        "offer": 15
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/6703405/2018/7/3/6ae532e9-9419-4342-96f6-37f0f047ffb61530620273965-Puma-Men-Black-Viz-Runner-Running-Shoes-821530620273760-1.jpg",
        "brand": "Puma",
        "type": "Men Viz Running Sports-Shoes",
        "price": "3574",
        "MP": "5499",
        "offer": 35
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14367616/2021/8/12/07269c5b-cd27-4716-9709-583e7eac513d1628768262239-US-Polo-Assn-Men-White-LEBRON-20-Walking-Shoes-3021628768261-1.jpg",
        "brand": "U.S. Polo Assn.",
        "type": "Men LEBRON 2.0 Walking Sports-Shoes",
        "price": "2399",
        "MP": "3999",
        "offer": 40
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/3/30/7426c955-48fd-48c1-994b-c2221f40f39a1617090592324-1.jpg",
        "brand": "Domyos By Decathlon",
        "type": "Men Training & Gym Sports-Shoes",
        "price": "2279",
        "MP": "3999",
        "offer": 43
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/10/14/860b14a7-5bcf-4d09-920d-91e2e9bebfa21602633763764-1.jpg",
        "brand": "Woakers",
        "type": "Men Running Sports-Shoes",
        "price": "681",
        "MP": "3405",
        "offer": 80
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/10/8/5f287707-5817-4322-85ab-ce1d8b4d424c1602114254212-1.jpg",
        "brand": "Puma",
        "type": "Men Minima Running Sports-Shoes",
        "price": "3249",
        "MP": "6499",
        "offer": 50
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12282146/2020/11/9/2f878da8-b88c-4bbd-997c-8a39e0f33e5b1604905105117-Puma-Men-Sports-Shoes-4491604905103244-1.jpg",
        "brand": "Puma",
        "type": "Men Runner IDP Running Sports-Shoes",
        "price": "2799",
        "MP": "3999",
        "offer": 30
      },
//   ]
  /////// Sports Shoes end here

  //// Sports & Active Wear start here
/// Sports Shoes  start here

///Fashion Accessories
// wallets   



// let Wallets = [
    {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14904086/2021/7/22/d68299c5-f479-45e0-846d-af08482bf78a1626967284512WildHornMenBrownSolid1.jpg",
        "brand": "WildHorn",
        "type": "Leather Two Fold Wallet",
        "price": "575",
        "MP": "2399",
        "offer": 76
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15214632/2021/8/21/3d1b5740-8050-4e09-8aa1-c340f9d9fe871629487576992MenTanSolidGenuineLeatherTwoFoldWallet1.jpg",
        "brand": "Teakwood Leathers",
        "type": "Men Solid Two-Fold Wallet",
        "price": "699",
        "MP": "1749",
        "offer": 60
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16532782/2021/12/16/50fccd28-6364-4729-a042-11bbd89d81261639644918709ProvogueMenBronzeSolid1.jpg",
        "brand": "Provogue",
        "type": "RFID Two Fold Wallet",
        "price": "389",
        "MP": "1299",
        "offer": 70
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14904040/2021/7/22/1e32d782-b609-4953-8116-06dd9f9155231626967393348WildHornMenBlackSolid1.jpg",
        "brand": "WildHorn",
        "type": "Men Solid Two-Fold Wallet",
        "price": "551",
        "MP": "2399",
        "offer": 77
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11281584/2020/1/21/4974621d-19b1-4724-8fdc-d067033325091579591268600-Mast--Harbour-Men-Navy-Blue-Solid-Two-Fold-Wallet-4941579591-1.jpg",
        "brand": "Mast & Harbour",
        "type": "Men Leather Two Fold Wallet",
        "price": "974",
        "MP": "1499",
        "offer": 35
      },
      
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2021/7/1/d012c347-4f0b-47ff-993b-731b5868a8d51625114961479-1.jpg",
        "brand": "LOUIS STITCH",
        "type": "Leather Two Fold Wallet with RFID",
        "price": "840",
        "MP": "4200",
        "offer": 80
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/11647832/2021/10/30/95bb5d76-9f0e-4551-ad84-e0d71f2facd31635567170117-WildHorn-Men-Brown-Solid-RFID-Protected-Genuine-Leather-Two--7.jpg",
        "brand": "WildHorn",
        "type": "RFID Protected Leather Wallet",
        "price": "539",
        "MP": "1999",
        "offer": 73
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/5568704/2022/2/25/f3895c8a-28e4-4724-a581-5a5e2969d6a21645781583712-Levis-Men-Brown-Textured-Zip-Around-Wallet-9161645781583145-1.jpg",
        "brand": "Levis",
        "type": "Men Textured Zip Around Wallet",
        "price": "1699",
        "MP": "1999",
        "offer": 15
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/7/3/0230c309-ef49-4621-8975-bc7071a785cd1593726087790-5.jpg",
        "brand": "Teakwood Leathers",
        "type": "Men Genuine Leather Accessory Gift Set",
        "price": "1399",
        "MP": "3999",
        "offer": 65
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/10/13/21f93cf5-cddf-4fde-bcb4-2a4b4120d9051602542304498-1.jpg",
        "brand": "WildHorn",
        "type": "Men RFID Protected Genuine Leather Accessory Gift Set",
        "price": "749",
        "MP": "2999",
        "offer": 75
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/9/18/b84a3dc8-b4b4-429d-b9cd-1bd89f9032741600383589268-7.jpg",
        "brand": "WildHorn",
        "type": "Men RFID Protected Genuine Leather Wallet & Pen Accessory Gift Set",
        "price": "839",
        "MP": "2999",
        "offer": 72
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/9/25/229a3f9a-c226-4c36-89c2-de1cb764ad6f1600989130005-1.jpg",
        "brand": "WildHorn",
        "type": "Men Leather Accessory Gift Set",
        "price": "1049",
        "MP": "2999",
        "offer": 65
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/9/18/806e9d57-2a10-423e-9698-92945fff5aae1600382535208-7.jpg",
        "brand": "WildHorn",
        "type": "Men RFID Protected Genuine Leather Wallet & Pen Accessory Gift Set",
        "price": "839",
        "MP": "2999",
        "offer": 72
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/9/25/77eb9427-1723-470d-aee4-d53c4f6eaa261600985088309-1.jpg",
        "brand": "WildHorn",
        "type": "Men RFID Protected Genuine Leather Accessory Gift Set",
        "price": "1049",
        "MP": "2999",
        "offer": 65
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/9/25/a6ce5f89-6222-4697-92fb-199b7e2ff34a1600989614723-1.jpg",
        "brand": "WildHorn",
        "type": "Men RFID Protected Genuine Leather Accessory Gift Set",
        "price": "1049",
        "MP": "2999",
        "offer": 65
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/2/29/64a72c00-2c97-4f75-a2e2-a00adffd21861582930075221-1.jpg",
        "brand": "WildHorn",
        "type": "Men RFID Protected Genuine Leather Wallet & Pen Accessory Gift Set",
        "price": "899",
        "MP": "2999",
        "offer": 70
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/1410362/2016/6/25/11466848469624-WildHorn-Men-Accessory-Gift-Set-2951466848469482-1.jpg",
        "brand": "WildHorn",
        "type": "Men Accessory Gift Set",
        "price": "1049",
        "MP": "2999",
        "offer": 65
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12346832/2020/8/27/11a13641-1878-44d8-9e56-2b73caff382a1598538414460WildHornMenBrownGenuineLeatherRFIDProtectedWalletBeltComboGi7.jpg",
        "brand": "WildHorn",
        "type": "Wallet & Belt Combo Gift Set",
        "price": "1139",
        "MP": "2999",
        "offer": 62
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/9/20/f9a05b21-eeb0-4b1b-88d8-70cb5b2e33d81600552127304-7.jpg",
        "brand": "WildHorn",
        "type": "Men RFID Protected Genuine Leather Accessory Gift Set",
        "price": "839",
        "MP": "2999",
        "offer": 72
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/12346950/2020/8/28/2fecd3b4-07b2-46a9-9f40-da9c108663c41598616777783WildHornMenBrownRFIDProtectedGenuineLeatherAccessoryGiftSet1.jpg",
        "brand": "WildHorn",
        "type": "Men RFID Protected Genuine Leather Accessory Gift Set",
        "price": "1139",
        "MP": "2999",
        "offer": 62
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/12/9/724d1bd7-b092-487f-970e-c003a62132381607504341477-1.jpg",
        "brand": "Pacific Gold",
        "type": "Men Genuine Leather Accessory Gift Set",
        "price": "1199",
        "MP": "3999",
        "offer": 70
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16167824/2021/11/19/01aa6a70-53ef-4783-be0a-11b54ca1330b1637296234250WildHornLeatherBeltWalletComboforMenLeatherGiftHamperIGiftsf1.jpg",
        "brand": "WildHorn",
        "type": "Men Textured Pure Genuine Leather Accessory Gift Set",
        "price": "1399",
        "MP": "3999",
        "offer": 65
      },
// ]
//// waltes end here 

///Belt start here


// let Belts = [
    {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/13749634/2021/3/9/1f9bf3e7-5da0-43d5-9a48-23ffd95d45f31615280726428-United-Colors-of-Benetton-Men-Belts-121615280725858-1.jpg",
        "brand": "United Colors of Benetton",
        "type": "Men Solid Belt",
        "price": "839",
        "MP": "1199",
        "offer": 30
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/15477188/2021/9/26/cb4475b0-282d-420e-8cec-03c6bb85c52d1632639295862-WildHorn-Men-Black-Textured-Leather-Formal-Belt-897163263929-11.jpg",
        "brand": "WildHorn",
        "type": "Textured Leather Formal Belt",
        "price": "549",
        "MP": "2499",
        "offer": 78
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/7271185/2018/9/18/a3a0379e-9e48-481e-9d9f-c1f5e8d047ba1537254640785-United-Colors-of-Benetton-Men-Belts-6291537254640739-1.jpg",
        "brand": "United Colors of Benetton",
        "type": "Men Solid Leather Belt",
        "price": "1034",
        "MP": "2299",
        "offer": 55
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16047714/2021/12/10/28d65caf-c3ca-4ea7-96a6-667a3e4b28011639121054603-United-Colors-of-Benetton-Men-Black-PU-Belt-5791639121054259-1.jpg",
        "brand": "United Colors of Benetton",
        "type": "Men Solid Belt",
        "price": "719",
        "MP": "1599",
        "offer": 55
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14881750/2021/9/21/2be43863-a577-425c-8ac4-93950bea10a91632223480430-Peter-England-Men-Belts-7831632223480206-1.jpg",
        "brand": "Peter England",
        "type": "Men Textured Reversible Belt",
        "price": "599",
        "MP": "1199",
        "offer": 50
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14032600/2021/4/7/843de55d-9058-46ef-89c8-66d995b303c81617801630666CRUSSETMenBlack1.jpg",
        "brand": "CRUSSET",
        "type": "Men Solid Leather Belt",
        "price": "455",
        "MP": "1899",
        "offer": 76
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14104944/2021/6/12/7c3824bb-0646-41f9-b3bf-439dc55f53ed1623492742365-United-Colors-of-Benetton-Mens-Faux-Leather-Reversible-Belt--1.jpg",
        "brand": "United Colors of Benetton",
        "type": "Men Textured Reversible Belt",
        "price": "719",
        "MP": "1599",
        "offer": 55
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16327370/2021/12/1/1e0be525-cb25-47a3-a43b-d2d27de53f821638367733982FusionThreadsMenBrownTextured1.jpg",
        "brand": "Fusion Threads",
        "type": "Men Leather Formal Belt",
        "price": "599",
        "MP": "1499",
        "offer": 60
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14104916/2021/11/12/e31e4c38-815e-461f-a96d-347342c444ac1636699508450-United-Colors-of-Benetton-Mens-Genuine-Leather-Belt-80416366-1.jpg",
        "brand": "United Colors of Benetton",
        "type": "Men Leather Formal Belt",
        "price": "1374",
        "MP": "2499",
        "offer": 45
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/16047680/2022/2/23/a1cd3feb-f259-4d7b-86de-f2b59608be681645609343557-United-Colors-of-Benetton-Men-Black-PU-Belt-1621645609343295-1.jpg",
        "brand": "United Colors of Benetton",
        "type": "Men Reversible Belt",
        "price": "989",
        "MP": "1799",
        "offer": 45
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2020/3/19/6e8374de-0eee-4e1d-ad9f-8051e35394a61584572702921-1.jpg",
        "brand": "CRUSSET",
        "type": "Men Solid Leather Belt",
        "price": "713",
        "MP": "1699",
        "offer": 58
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14881828/2021/10/6/231128e0-24ae-48df-8df8-1fcea8312bbb1633522283993-Peter-England-Men-Belts-3581633522283820-1.jpg",
        "brand": "Peter England",
        "type": "Men Reversible Formal Belt",
        "price": "779",
        "MP": "1299",
        "offer": 40
      },
      
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/productimage/2018/10/23/ec5984f1-00d5-4dbd-be2f-fd5bef7a4ea11540319220478-1.jpg",
        "brand": "SPYKAR",
        "type": "Belts",
        "price": "1199",
        "MP": "1999",
        "offer": 40
      },
      {
        "image": "https://assets.myntassets.com/h_560,q_90,w_420/v1/assets/images/14104778/2021/12/22/d7c2d574-cbab-4474-83db-a082e610c9a41640177072481-United-Colors-of-Benetton-Mens-Genuine-Leather-Belt-69816401-1.jpg",
        "brand": "United Colors of Benetton",
        "type": "Men Laser Cuts Leather Belt",
        "price": "1374",
        "MP": "2499",
        "offer": 45
      },
]

//// belts  data end here 

export default Data;

// function mens_navbar_items(arr,name,id){
//   arr.map(function(el){
//     let appendData=document.getElementById(id)
//     let div1=document.createElement("div")
//     let img=document.createElement("img")
//     let brand=document.createElement("h3")
//     let type=document.createElement("p")
//     let price=document.createElement("p")
//     let MP=document.createElement("s")
//     let offer=document.createElement("p")
  
  
//     div1.id="inner_div"
//     img.src=el.image;
//     img.id="img1"
  
  
  
    
//     brand.innerText=el.brand;
//     brand.id="brand1"
  
   
//     type.innerText=el.title;
//     type.id="type1"
     
//     let div2=document.createElement("div")
//     div2.id="div_2"
//     let div3=document.createElement("div")
//     div3.id="div_3"
//     price.innerText=el.price;
//     price.id="price1"
//     MP.innerText=el.actualPrice;
//     MP.id="mp1"
//     offer.innerText=el.offerer;
//     offer.id="offer1"
  
  
    
//     div3.append(price,MP,offer)
//     div2.append(div3)
//     div1.append(img,brand,type,div2)
  
//     appendData.append(div1)
  
  
//     localStorage.setItem(name,JSON.stringify(arr))
//     console.log("inside")
  
//   })
// }


//  mens_navbar_items(SportsShoesArr,"SportsShoes_n","a2")
//  mens_navbar_items( Wallets," Wallets_n","a1")
//  mens_navbar_items( jeansArr," jeansArr_n","a3")